/**
 * AboutARAboutChecksDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AboutARAboutChecksDemo
 */

import { useAboutARAboutChecksDemoLogic } from '@/hooks/traits/useAboutARAboutChecksDemoLogic';
import type { AboutARAboutChecksDemoConfig } from '@/hooks/traits/useAboutARAboutChecksDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AboutARDemoCheck } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { AboutARDemoChecksTourView } from '@/components/traits/AboutARDemoChecksTourView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AboutARAboutChecksDemoViewProps {
  config?: Partial<AboutARAboutChecksDemoConfig>;
}

export function AboutARAboutChecksDemoView({ config: propsConfig }: AboutARAboutChecksDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAboutARAboutChecksDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AboutARDemoCheck'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AboutAR" trait="AboutARAboutChecksDemo">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="md"><AboutARDemoChecksTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default AboutARAboutChecksDemoView;
